import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import { antdThemeConfig } from './config/antd';
import { AuthProvider } from './contexts/AuthContext';
import { LocaleProvider } from './contexts/LocaleContext';
import { ConfigProvider as AppConfigProvider } from './contexts/ConfigContext';
import { ApiErrorProvider } from './contexts/ApiErrorContext';
import { CalendarProvider } from './contexts/CalendarContext';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppConfigProvider>
      <LocaleProvider>
        <AuthProvider>
          <ApiErrorProvider>
            <CalendarProvider>
              <ConfigProvider theme={antdThemeConfig}>
                <App />
              </ConfigProvider>
            </CalendarProvider>
          </ApiErrorProvider>
        </AuthProvider>
      </LocaleProvider>
    </AppConfigProvider>
  </React.StrictMode>
);

reportWebVitals();
